<template>
  <service-autocomplete
    dense
    @input="handleInputChange"
    @newItem="$emit('newItem', $event)"
    :value="value"
    :placeholder="generateMessage('actions.create.properties')"
    :url="url"
    solo
    cache-items
    v-bind="$attrs"
    ref="autocomplete"
    id-field="node_id"
    :search-attributes-array="['code', 'shortname']"
    use-entities
  >
    <template v-slot:item="{ item }">
      {{ item.code + ' - ' + item.shortname }}
    </template>
    <template v-slot:selection="{ selected, item }">
      <v-chip
        small
        :value="selected"
        close
        @click:close="$refs.autocomplete.handleInputRemove(item)"
      >
        {{ item.code + ' - ' + item.shortname }}
      </v-chip>
    </template>
  </service-autocomplete>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import ServiceAutocomplete from '@/components/selects/ServiceAutocomplete';

export default {
  name: 'custom-properties-selector',
  components: { ServiceAutocomplete },
  props: {
    value: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      url: `${process.env.MYPREDITY_BASE_URI}/properties`,
    };
  },
  methods: {
    generateMessage,
    handleInputChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>
